webpackJsonp(["users"],{

/***/ "./activities.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pager__ = __webpack_require__("./pager.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-param-reassign, class-methods-use-this */





var Activities = function () {
  function Activities() {
    var _this = this;

    _classCallCheck(this, Activities);

    __WEBPACK_IMPORTED_MODULE_1__pager__["a" /* default */].init(20, true, false, function (data) {
      return data;
    }, this.updateTooltips);

    $('.event-filter-link').on('click', function (e) {
      e.preventDefault();
      _this.toggleFilter(e.currentTarget);
      _this.reloadActivities();
    });
  }

  _createClass(Activities, [{
    key: 'updateTooltips',
    value: function updateTooltips() {
      Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datetime_utility__["e" /* localTimeAgo */])($('.js-timeago', '.content_list'));
    }
  }, {
    key: 'reloadActivities',
    value: function reloadActivities() {
      $('.content_list').html('');
      __WEBPACK_IMPORTED_MODULE_1__pager__["a" /* default */].init(20, true, false, function (data) {
        return data;
      }, this.updateTooltips);
    }
  }, {
    key: 'toggleFilter',
    value: function toggleFilter(sender) {
      var $sender = $(sender);
      var filter = $sender.attr('id').split('_')[0];

      $('.event-filter .active').removeClass('active');
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('event_filter', filter);

      $sender.closest('li').toggleClass('active');
    }
  }]);

  return Activities;
}();

/* harmony default export */ __webpack_exports__["a"] = (Activities);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pager.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");




var ENDLESS_SCROLL_BOTTOM_PX = 400;
var ENDLESS_SCROLL_FIRE_DELAY_MS = 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var preload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var disable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var prepareData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $.noop;
    var callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $.noop;

    this.url = $('.content_list').data('href') || Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_url_utility__["f" /* removeParams */])(['limit', 'offset']);
    this.limit = limit;
    this.offset = parseInt(Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["g" /* getParameterByName */])('offset'), 10) || this.limit;
    this.disable = disable;
    this.prepareData = prepareData;
    this.callback = callback;
    this.loading = $('.loading').first();
    if (preload) {
      this.offset = 0;
      this.getOld();
    }
    this.initLoadMore();
  },
  getOld: function getOld() {
    var _this = this;

    this.loading.show();
    __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(this.url, {
      params: {
        limit: this.limit,
        offset: this.offset
      }
    }).then(function (_ref) {
      var data = _ref.data;

      _this.append(data.count, _this.prepareData(data.html));
      _this.callback();

      // keep loading until we've filled the viewport height
      if (!_this.disable && !_this.isScrollable()) {
        _this.getOld();
      } else {
        _this.loading.hide();
      }
    }).catch(function () {
      return _this.loading.hide();
    });
  },
  append: function append(count, html) {
    $('.content_list').append(html);
    if (count > 0) {
      this.offset += count;
    } else {
      this.disable = true;
    }
  },
  isScrollable: function isScrollable() {
    var $w = $(window);
    return $(document).height() > $w.height() + $w.scrollTop() + ENDLESS_SCROLL_BOTTOM_PX;
  },
  initLoadMore: function initLoadMore() {
    var _this2 = this;

    $(document).unbind('scroll');
    $(document).endlessScroll({
      bottomPixels: ENDLESS_SCROLL_BOTTOM_PX,
      fireDelay: ENDLESS_SCROLL_FIRE_DELAY_MS,
      fireOnce: true,
      ceaseFire: function ceaseFire() {
        return _this2.disable === true;
      },
      callback: function callback() {
        if (!_this2.loading.is(':visible')) {
          _this2.loading.show();
          _this2.getOld();
        }
      }
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./users/activity_calendar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_scale__ = __webpack_require__("../../../node_modules/d3-scale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_selection__ = __webpack_require__("../../../node_modules/d3-selection/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locale__ = __webpack_require__("./locale/index.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var d3 = { select: __WEBPACK_IMPORTED_MODULE_2_d3_selection__["f" /* select */], scaleLinear: __WEBPACK_IMPORTED_MODULE_1_d3_scale__["a" /* scaleLinear */], scaleThreshold: __WEBPACK_IMPORTED_MODULE_1_d3_scale__["b" /* scaleThreshold */] };

var LOADING_HTML = '\n  <div class="text-center">\n    <i class="fa fa-spinner fa-spin user-calendar-activities-loading"></i>\n  </div>\n';

function getSystemDate(systemUtcOffsetSeconds) {
  var date = new Date();
  var localUtcOffsetMinutes = 0 - date.getTimezoneOffset();
  var systemUtcOffsetMinutes = systemUtcOffsetSeconds / 60;
  date.setMinutes(date.getMinutes() - localUtcOffsetMinutes + systemUtcOffsetMinutes);
  return date;
}

function formatTooltipText(_ref) {
  var date = _ref.date,
      count = _ref.count;

  var dateObject = new Date(date);
  var dateDayName = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_datetime_utility__["c" /* getDayName */])(dateObject);
  var dateText = dateObject.format('mmm d, yyyy');

  var contribText = '没有贡献';
  if (count > 0) {
    contribText = count + ' \u6B21\u8D21\u732E';
  }
  return contribText + '<br />' + dateDayName + ' ' + dateText;
}

var initColorKey = function initColorKey() {
  return d3.scaleLinear().range(['#acd5f2', '#254e77']).domain([0, 3]);
};

var ActivityCalendar = function () {
  function ActivityCalendar(container, timestamps, calendarActivitiesPath) {
    var utcOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    _classCallCheck(this, ActivityCalendar);

    this.calendarActivitiesPath = calendarActivitiesPath;
    this.clickDay = this.clickDay.bind(this);
    this.currentSelectedDate = '';
    this.daySpace = 1;
    this.daySize = 15;
    this.daySizeWithSpace = this.daySize + this.daySpace * 2;
    this.monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    this.months = [];

    // Loop through the timestamps to create a group of objects
    // The group of objects will be grouped based on the day of the week they are
    this.timestampsTmp = [];
    var group = 0;

    var today = getSystemDate(utcOffset);
    today.setHours(0, 0, 0, 0, 0);

    var oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);

    var days = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_datetime_utility__["b" /* getDayDifference */])(oneYearAgo, today);

    for (var i = 0; i <= days; i += 1) {
      var date = new Date(oneYearAgo);
      date.setDate(date.getDate() + i);

      var day = date.getDay();
      var count = timestamps[date.format('yyyy-mm-dd')] || 0;

      // Create a new group array if this is the first day of the week
      // or if is first object
      if (day === 0 && i !== 0 || i === 0) {
        this.timestampsTmp.push([]);
        group += 1;
      }

      // Push to the inner array the values that will be used to render map
      var innerArray = this.timestampsTmp[group - 1];
      innerArray.push({ count: count, date: date, day: day });
    }

    // Init color functions
    this.colorKey = initColorKey();
    this.color = this.initColor();

    // Init the svg element
    this.svg = this.renderSvg(container, group);
    this.renderDays();
    this.renderMonths();
    this.renderDayTitles();
    this.renderKey();

    // Init tooltips
    $(container + ' .js-tooltip').tooltip({ html: true });
  }

  // Add extra padding for the last month label if it is also the last column


  _createClass(ActivityCalendar, [{
    key: 'getExtraWidthPadding',
    value: function getExtraWidthPadding(group) {
      var extraWidthPadding = 0;
      var lastColMonth = this.timestampsTmp[group - 1][0].date.getMonth();
      var secondLastColMonth = this.timestampsTmp[group - 2][0].date.getMonth();

      if (lastColMonth !== secondLastColMonth) {
        extraWidthPadding = 6;
      }

      return extraWidthPadding;
    }
  }, {
    key: 'renderSvg',
    value: function renderSvg(container, group) {
      var width = (group + 1) * this.daySizeWithSpace + this.getExtraWidthPadding(group);
      return d3.select(container).append('svg').attr('width', width).attr('height', 167).attr('class', 'contrib-calendar');
    }
  }, {
    key: 'renderDays',
    value: function renderDays() {
      var _this = this;

      this.svg.selectAll('g').data(this.timestampsTmp).enter().append('g').attr('transform', function (group, i) {
        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(group, function (stamp, a) {
          if (a === 0 && stamp.day === 0) {
            var month = stamp.date.getMonth();
            var x = _this.daySizeWithSpace * i + 1 + _this.daySizeWithSpace;
            var lastMonth = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.last(_this.months);
            if (lastMonth == null || month !== lastMonth.month && x - _this.daySizeWithSpace !== lastMonth.x) {
              _this.months.push({ month: month, x: x });
            }
          }
        });
        return 'translate(' + (_this.daySizeWithSpace * i + 1 + _this.daySizeWithSpace) + ', 18)';
      }).selectAll('rect').data(function (stamp) {
        return stamp;
      }).enter().append('rect').attr('x', '0').attr('y', function (stamp) {
        return _this.daySizeWithSpace * stamp.day;
      }).attr('width', this.daySize).attr('height', this.daySize).attr('fill', function (stamp) {
        return stamp.count !== 0 ? _this.color(Math.min(stamp.count, 40)) : '#ededed';
      }).attr('title', function (stamp) {
        return formatTooltipText(stamp);
      }).attr('class', 'user-contrib-cell js-tooltip').attr('data-container', 'body').on('click', this.clickDay);
    }
  }, {
    key: 'renderDayTitles',
    value: function renderDayTitles() {
      var days = [{
        text: 'M',
        y: 29 + this.daySizeWithSpace * 1
      }, {
        text: 'W',
        y: 29 + this.daySizeWithSpace * 3
      }, {
        text: 'F',
        y: 29 + this.daySizeWithSpace * 5
      }];
      this.svg.append('g').selectAll('text').data(days).enter().append('text').attr('text-anchor', 'middle').attr('x', 8).attr('y', function (day) {
        return day.y;
      }).text(function (day) {
        return day.text;
      }).attr('class', 'user-contrib-text');
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var _this2 = this;

      this.svg.append('g').attr('direction', 'ltr').selectAll('text').data(this.months).enter().append('text').attr('x', function (date) {
        return date.x;
      }).attr('y', 10).attr('class', 'user-contrib-text').text(function (date) {
        return _this2.monthNames[date.month];
      });
    }
  }, {
    key: 'renderKey',
    value: function renderKey() {
      var _this3 = this;

      var keyValues = ['no contributions', '1-9 contributions', '10-19 contributions', '20-29 contributions', '30+ contributions'];
      var keyColors = ['#ededed', this.colorKey(0), this.colorKey(1), this.colorKey(2), this.colorKey(3)];

      this.svg.append('g').attr('transform', 'translate(18, ' + (this.daySizeWithSpace * 8 + 16) + ')').selectAll('rect').data(keyColors).enter().append('rect').attr('width', this.daySize).attr('height', this.daySize).attr('x', function (color, i) {
        return _this3.daySizeWithSpace * i;
      }).attr('y', 0).attr('fill', function (color) {
        return color;
      }).attr('class', 'js-tooltip').attr('title', function (color, i) {
        return keyValues[i];
      }).attr('data-container', 'body');
    }
  }, {
    key: 'initColor',
    value: function initColor() {
      var colorRange = ['#ededed', this.colorKey(0), this.colorKey(1), this.colorKey(2), this.colorKey(3)];
      return d3.scaleThreshold().domain([0, 10, 20, 30]).range(colorRange);
    }
  }, {
    key: 'clickDay',
    value: function clickDay(stamp) {
      if (this.currentSelectedDate !== stamp.date) {
        this.currentSelectedDate = stamp.date;

        var date = [this.currentSelectedDate.getFullYear(), this.currentSelectedDate.getMonth() + 1, this.currentSelectedDate.getDate()].join('-');

        $('.user-calendar-activities').html(LOADING_HTML);

        __WEBPACK_IMPORTED_MODULE_4__lib_utils_axios_utils__["a" /* default */].get(this.calendarActivitiesPath, {
          params: {
            date: date
          },
          responseType: 'text'
        }).then(function (_ref2) {
          var data = _ref2.data;
          return $('.user-calendar-activities').html(data);
        }).catch(function () {
          return Object(__WEBPACK_IMPORTED_MODULE_5__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__locale__["__"])('An error occurred while retrieving calendar activity'));
        });
      } else {
        this.currentSelectedDate = '';
        $('.user-calendar-activities').html('');
      }
    }
  }]);

  return ActivityCalendar;
}();

/* harmony default export */ __webpack_exports__["a"] = (ActivityCalendar);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./users/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_tabs__ = __webpack_require__("./users/user_tabs.js");



function initUserProfile(action) {
  var _this = this;

  // place profile avatars to top
  $('.profile-groups-avatars').tooltip({
    placement: 'top'
  });

  // eslint-disable-next-line no-new
  new __WEBPACK_IMPORTED_MODULE_1__user_tabs__["a" /* default */]({ parentEl: '.user-profile', action: action });

  // hide project limit message
  $('.hide-project-limit-message').on('click', function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_project_limit_message', 'false');
    $(_this).parents('.project-limit-message').remove();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  var page = $('body').attr('data-page');
  var action = page.split(':')[1];
  initUserProfile(action);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./users/user_tabs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__activities__ = __webpack_require__("./activities.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__activity_calendar__ = __webpack_require__("./users/activity_calendar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flash__ = __webpack_require__("./flash.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








/**
 * UserTabs
 *
 * Handles persisting and restoring the current tab selection and lazily-loading
 * content on the Users#show page.
 *
 * ### Example Markup
 *
 * <ul class="nav-links">
 *   <li class="activity-tab active">
 *     <a data-action="activity" data-target="#activity" data-toggle="tab" href="/u/username">
 *       Activity
 *     </a>
 *   </li>
 *   <li class="groups-tab">
 *     <a data-action="groups" data-target="#groups" data-toggle="tab" href="/u/username/groups">
 *       Groups
 *     </a>
 *   </li>
 *   <li class="contributed-tab">
 *     ...
 *   </li>
 *   <li class="projects-tab">
 *     ...
 *   </li>
 *   <li class="snippets-tab">
 *     ...
 *   </li>
 * </ul>
 *
 * <div class="tab-content">
 *   <div class="tab-pane" id="activity">
 *     Activity Content
 *   </div>
 *   <div class="tab-pane" id="groups">
 *     Groups Content
 *   </div>
 *   <div class="tab-pane" id="contributed">
 *     Contributed projects content
 *   </div>
 *   <div class="tab-pane" id="projects">
 *    Projects content
 *   </div>
 *   <div class="tab-pane" id="snippets">
 *     Snippets content
 *   </div>
 * </div>
 *
 * <div class="loading-status">
 *   <div class="loading">
 *     Loading Animation
 *   </div>
 * </div>
 */

var CALENDAR_TEMPLATE = '\n  <div class="clearfix calendar">\n    <div class="js-contrib-calendar"></div>\n    <div class="calendar-hint">\n      \u95EE\u9898\u3001\u5408\u5E76\u8BF7\u6C42\u3001\u63A8\u9001\u4E8B\u4EF6\u548C\u8BC4\u8BBA\u6458\u8981\n    </div>\n  </div>\n';

var UserTabs = function () {
  function UserTabs(_ref) {
    var _this = this;

    var defaultAction = _ref.defaultAction,
        action = _ref.action,
        parentEl = _ref.parentEl;

    _classCallCheck(this, UserTabs);

    this.loaded = {};
    this.defaultAction = defaultAction || 'activity';
    this.action = action || this.defaultAction;
    this.$parentEl = $(parentEl) || $(document);
    this.windowLocation = window.location;
    this.$parentEl.find('.nav-links a').each(function (i, navLink) {
      _this.loaded[$(navLink).attr('data-action')] = false;
    });
    this.actions = Object.keys(this.loaded);
    this.bindEvents();

    if (this.action === 'show') {
      this.action = this.defaultAction;
    }

    this.activateTab(this.action);
  }

  _createClass(UserTabs, [{
    key: 'bindEvents',
    value: function bindEvents() {
      var _this2 = this;

      this.$parentEl.off('shown.bs.tab', '.nav-links a[data-toggle="tab"]').on('shown.bs.tab', '.nav-links a[data-toggle="tab"]', function (event) {
        return _this2.tabShown(event);
      }).on('click', '.gl-pagination a', function (event) {
        return _this2.changeProjectsPage(event);
      });
    }
  }, {
    key: 'changeProjectsPage',
    value: function changeProjectsPage(e) {
      e.preventDefault();

      $('.tab-pane.active').empty();
      var endpoint = $(e.target).attr('href');
      this.loadTab(this.getCurrentAction(), endpoint);
    }
  }, {
    key: 'tabShown',
    value: function tabShown(event) {
      var $target = $(event.target);
      var action = $target.data('action');
      var source = $target.attr('href');
      var endpoint = $target.data('endpoint');
      this.setTab(action, endpoint);
      return this.setCurrentAction(source);
    }
  }, {
    key: 'activateTab',
    value: function activateTab(action) {
      return this.$parentEl.find('.nav-links .js-' + action + '-tab a').tab('show');
    }
  }, {
    key: 'setTab',
    value: function setTab(action, endpoint) {
      if (this.loaded[action]) {
        return;
      }
      if (action === 'activity') {
        this.loadActivities();
      }

      var loadableActions = ['groups', 'contributed', 'projects', 'snippets'];
      if (loadableActions.indexOf(action) > -1) {
        this.loadTab(action, endpoint);
      }
    }
  }, {
    key: 'loadTab',
    value: function loadTab(action, endpoint) {
      var _this3 = this;

      this.toggleLoading(true);

      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].get(endpoint).then(function (_ref2) {
        var data = _ref2.data;

        var tabSelector = 'div#' + action;
        _this3.$parentEl.find(tabSelector).html(data.html);
        _this3.loaded[action] = true;
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_datetime_utility__["e" /* localTimeAgo */])($('.js-timeago', tabSelector));

        _this3.toggleLoading(false);
      }).catch(function () {
        _this3.toggleLoading(false);
      });
    }
  }, {
    key: 'loadActivities',
    value: function loadActivities() {
      if (this.loaded.activity) {
        return;
      }
      var $calendarWrap = this.$parentEl.find('.user-calendar');
      var calendarPath = $calendarWrap.data('calendarPath');
      var calendarActivitiesPath = $calendarWrap.data('calendarActivitiesPath');
      var utcOffset = $calendarWrap.data('utcOffset');
      var utcFormatted = 'UTC';
      if (utcOffset !== 0) {
        utcFormatted = 'UTC' + (utcOffset > 0 ? '+' : '') + utcOffset / 3600;
      }

      __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].get(calendarPath).then(function (_ref3) {
        var data = _ref3.data;

        $calendarWrap.html(CALENDAR_TEMPLATE);
        $calendarWrap.find('.calendar-hint').append('(Timezone: ' + utcFormatted + ')');

        // eslint-disable-next-line no-new
        new __WEBPACK_IMPORTED_MODULE_2__activity_calendar__["a" /* default */]('.js-contrib-calendar', data, calendarActivitiesPath, utcOffset);
      }).catch(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_5__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__locale__["__"])('There was an error loading users activity calendar.'));
      });

      // eslint-disable-next-line no-new
      new __WEBPACK_IMPORTED_MODULE_1__activities__["a" /* default */]();
      this.loaded.activity = true;
    }
  }, {
    key: 'toggleLoading',
    value: function toggleLoading(status) {
      return this.$parentEl.find('.loading-status .loading').toggle(status);
    }
  }, {
    key: 'setCurrentAction',
    value: function setCurrentAction(source) {
      var newState = source;
      newState = newState.replace(/\/+$/, '');
      newState += this.windowLocation.search + this.windowLocation.hash;
      history.replaceState({
        url: newState
      }, document.title, newState);
      return newState;
    }
  }, {
    key: 'getCurrentAction',
    value: function getCurrentAction() {
      return this.$parentEl.find('.nav-links .active a').data('action');
    }
  }]);

  return UserTabs;
}();

/* harmony default export */ __webpack_exports__["a"] = (UserTabs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["./users/index.js"]);


// WEBPACK FOOTER //
// users.43910384fa25a53a993b.bundle.js